(function (angular) {
  angular.module("alk.linkMapping", []);
})(window.angular);

require("./alkLinkMapping.service");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-link-mapping/module.js